import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GroundworksAuthLifecycleService } from '@groundworks/ngx-groundworks-auth';
import { ToastContainerComponent } from '@groundworks/ngx-groundworks-ui';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastContainerComponent],
  template: `<router-outlet /><groundworks-toast-container />`,
  styleUrl: './app.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly auth = inject(GroundworksAuthLifecycleService);

  ngOnInit(): void {
    this.auth.start();
  }

  ngOnDestroy(): void {
    this.auth.stop();
  }
}
